import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { borderStyle, borderRadiusStyle,boxShadow,dimensions, background,position,flex, widthStyle} from "@vayu-blocks/global";
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { omitBy } from 'lodash';

export const VayuBlockAdvanceStyle = (attributes,defaultblocks='') => {

    const [isHovered, setIsHovered] = useState(false);
    const getView = VayuBlocksDevice(); // Assume this is globally available

    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);

    const handelDefaultContainer = (advPadding,defaultblocks) => {
            if(defaultblocks==='container'){
                const ThBlockDataPadding = {bottom:vayublock.options.global.containerPadding+"px",
                    left:vayublock.options.global.containerPadding+"px",
                    right:vayublock.options.global.containerPadding+"px",
                    top:vayublock.options.global.containerPadding+"px"}
                
                    const defaultPadding = {Desktop:ThBlockDataPadding,
                                            Tablet:ThBlockDataPadding,
                                            Mobile:ThBlockDataPadding,
                                            }


                        return advPadding ?? defaultPadding
            }else{
                return advPadding;
            }
    }

    const cursorStyle = attributes.advFollower?.hideCursor && attributes.advFollower?.type !== 'none'
    ? 'none' : attributes.advCursor?.customImage
        ? `url(${attributes.advCursor?.customImage}), auto`
        : 'auto';

    const styles = {
        ...widthStyle(attributes.advWidth, getView),
        padding: dimensions(handelDefaultContainer(attributes.advPadding,defaultblocks), getView),
        ...(attributes.advMargin? { margin: dimensions(attributes.advMargin, getView) }: 
        attributes?.advWidth?.value === 'customwidth'? { margin: '0' }: {}),
        ...borderStyle(attributes.advBorder, getView),
        ...borderRadiusStyle(attributes.advBorderRadius, getView),
        ...boxShadow(attributes.advDropShadow, getView),
        ...background(attributes.advBackground),
        ...position(attributes.advPosition, getView),
        ...flex(attributes.advFlexItem, getView),
        transition: attributes.advTransition ? `all ${attributes.advTransition}s ease` : undefined,
        animationDuration: attributes.advTransition ? `${attributes.advTransition}s` : undefined,
        cursor: cursorStyle,
    };

    const hoverStyles = {
        ...borderStyle(attributes.advBorderHover, getView, attributes.advBorder),
        ...borderRadiusStyle(attributes.advBorderRadiusHover, getView, attributes.advBorderRadius),
        ...boxShadow(attributes.advDropShadowHover, getView, attributes.advDropShadow),
        ...background(attributes.advBackgroundHover, true , attributes.advBackground),
    };

    const filteredHoverStyles = omitBy(hoverStyles, value => !value);
 
    const mergedStyles = {
        ...styles,
        ...(isHovered ? filteredHoverStyles : {}),
    };

	const responsiveClasses = [
		attributes?.advResponsive?.Desktop ? 'vb-th-hide-desktop' : '',
		attributes?.advResponsive?.Tablet ? 'vb-th-hide-tablet' : '',
		attributes?.advResponsive?.Mobile ? 'vb-th-hide-mobile' : '',
        (attributes?.advWidth?.value === 'fullwidth' || attributes?.advWidth?.value === 'customwidth') ? 'alignfull' : ''
	].filter(Boolean).join(' ');

    const animationClass = attributes?.advAnimation?.className || '';

	const hoverAnimationClass = animationClass.trim();
    
    return {
        mergedStyles,
        handleMouseEnter,
        handleMouseLeave,
        isHovered,
        responsiveClasses,
        hoverAnimationClass,
    };
}
